var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","max-width":"500"},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('v-icon',_vm._g({},on),[_vm._v("mdi-information-outline")])]}}])},[_c('span',[_vm._v("En este apartado se eligen los diferentes materiales que forman parte de la solución constructiva.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }